import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {RegisterSignatureComponent} from '../../../../e-signature/register-signature/register-signature.component';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {IdexService} from "../../../../idex.service";
import {ConfirmDialogComponent} from "../../../../e-signature/confirm-dialog/confirm-dialog.component";
import {TranslateService} from "@ngx-translate/core";
import {EformService} from "../../../service/eform.service";
import { ActivatedRoute } from '@angular/router';
import { TaskAttribute } from 'app/e-signature/create-task/create-task.type';
import { DynamicFormBuilderService } from '../../dynamic-form-builder/dynamic-form-builder.service';
import { Observable, Subscription } from 'rxjs';

@Component({
   selector: 'app-signature',
   templateUrl: './signature.component.html',
   styleUrls: ['./signature.component.css']
})
export class SignatureComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() classes: any;
   @Input() fieldName: any;
   @Input() labelName: any;
   @Input() imageNoSignaturePreview: any;
   @Input() imageSignaturePreview: any;
   @Input() imageInitializePreview: any;
   @Input() fNameValue: any;
   @Input() lNameValue: any;
   @Input() isPreview: boolean;
   @Input() isCreateFile: boolean;
   @Input() isViewOnly: boolean;
   @Input() haveSign: boolean;
   @Input() taskAttribute: TaskAttribute;
   @Input() isStartFlow: boolean;
   @Output() selectSig = new EventEmitter<any>();
   @Output() showSignTool = new EventEmitter<any>();
   @Output() signAllForm = new EventEmitter();
   errorMessage: any;
   uploadError = false;
   errorMessageMaxSize = false;
   checkValid = false;
   hasSignature: any;
   picSign: any;
   formType: string;
   disabledRejectTask = false;
   defaultCursor = false;
   taskContactId;
   openPopup = false;
   isSigner: boolean = true;
   protected indexForm: number;

   /**
    * True – ยอมให้แสดงขอบ error ไม่ได้กรอกค่าที่จำเป็นต้องกรอก (ถ้ามี) \
    * False – ไม่ยอมให้แสดงขอบ error
    *
    * กรอบจะถูกแสดงเมื่อ
    * - มีการกดปุ่ม send form และมี required field ว่างอยู่
    *
    * กรอบจะไม่ถูกแสดงเมื่อ
    * - เปิดฟอร์มครั้งแรก
    * - User เลือกหรือเปลี่ยนแปลง signer
    */
   protected allowShowFieldEmptyErrorBorder: boolean = false;

   /**
    * True – ยอมให้แสดงข้อความ 'Required' ใต้ required field
    * False – ไม่ยอมให้แสดงข้อความ 'Required'
    *
    * ข้อความจะถูกแสดงเมื่อ
    * - เปิดฟอร์มครั้งแรก
    * - มีการกดปุ่ม send form และมี required field ว่างอยู่
    *
    * ข้อความจะไม่ถูกแสดงเมื่อ
    * - User เลือกหรือเปลี่ยนแปลง signer
    */
   protected allowShowRequiredText: boolean = true;

   private showFieldEmptyError: Subscription;
   private fieldValueChanges: Subscription;

   constructor(
      public dialog: MatDialog,
      public service: IdexService,
      private translate: TranslateService,
      private eformService: EformService,
      private ref: ChangeDetectorRef,
      private router: ActivatedRoute,
      private dynamicFormBuilderService: DynamicFormBuilderService,
   ) {
      this.service.getProfile()
         .subscribe((data: any) => {
            this.hasSignature = data.hasSignature;
            if (!this.fNameValue) {
               this.fNameValue = data.fName;
            }
            if (!this.lNameValue) {
               this.lNameValue = data.lName;
            }
         });

      let typeName = this.router.snapshot.queryParams.data ? JSON.parse(this.router.snapshot.queryParams.data).typeName : null;

      if (typeName === 'startFlow') {
         this.formType = 'NF';
      } else if (localStorage.getItem('form-type') === 'dms') {
         this.formType = 'NF';
      } else if (localStorage.getItem('form-type') === 'view') {
         this.formType = 'VF';
      } else if (localStorage.getItem('form-type') === 'form') {
         this.formType = 'FM';
      } else {
         this.formType = 'TP';
      }

      this.router.url.subscribe(val => {
         if (val[0].path === 'signdoc') {
            this.formType = 'FM';
         } else if (val[0].path === 'create-task') {
            this.formType = 'NF'
         }
      });
   }

   ngOnInit(): void {
      this.showFieldEmptyError = this.dynamicFormBuilderService.showFieldEmptyError$.subscribe(() => {
         this.allowShowFieldEmptyErrorBorder = true;
         this.allowShowRequiredText = true;
         this.ref.detectChanges();
      });

      this.fieldValueChanges = (this.form?.get(this.fieldName)?.valueChanges as Observable<string>)?.subscribe(value => {
         if (value) {
            this.allowShowFieldEmptyErrorBorder = false;
            this.allowShowRequiredText = false;
         } else {
            this.allowShowRequiredText = true;
         }
         this.ref.detectChanges();
      });

      this.indexForm = this.taskAttribute?.docList.findIndex(o => o.docName.toLowerCase().endsWith('.zdox'));
      if (!this.eformService.taskAttributeTemp && !this.eformService.taskAttributeTemp?.apvLevel) {
         this.picSign = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.picSign;
      }

      this.handleSignature();

      this.hideOrOpenSignature(this.indexForm);

      this.showSignSignature(this.indexForm);

      this.ref.detectChanges();
   }

   ngAfterViewInit(): void {
      let getSigner;
      if (this.eformService.taskAttributeTemp && this.eformService.taskAttributeTemp.apvLevel) {
         getSigner = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.picSign;
         if (getSigner) {
            let getSignersItem, indexColor, element;
            for (const signers of this.eformService.taskAttributeTemp.apvLevel) {
               for (const signer of signers.signerList) {
                  if (signer.signerEmail === getSigner) {
                     getSignersItem = signer;
                  }
               }
            }
            element = document.getElementById('holder' + this.fieldName);
            if (element && getSignersItem) {
               indexColor = this.setIndexColorDocList(getSignersItem);
               this.taskContactId = getSignersItem.taskContactId;
               element.style.backgroundColor = this.eformService.colors[indexColor];
               element.style.opacity = '0.5';
               this.form.controls[this.fieldName].setValue(getSigner);
            }
            this.onshowSignTool(true);
         }
      }
      this.ref.detectChanges();
   }

   hideOrOpenSignature(indexForm){
      if ((this.taskAttribute?.taskStatus === 'Reject' || this.taskAttribute?.taskStatus === 'Completed' || history.state.docStatus === 'Completed' || history.state.docStatus === 'Reject') && !this.picSign) {
         this.disabledRejectTask = true;
      } else {
         if (this.taskAttribute) {
            if (!this.isEmpty(this.form.controls[this.fieldName].value) && !this.haveSign) {
               this.defaultCursor = true;
            }
            const currentSigner = this.taskAttribute?.apvLevel.find(signer => signer.order === this.taskAttribute.currentLevel);
            const taskContact = currentSigner?.signerList.find(element => element.signerEmail === this.service.user.email || element?.reassignEmail === this.service.user.email);
            if (currentSigner && taskContact && this.taskAttribute?.docList[indexForm]?.signItems) {
               const haveToSignItem = this.taskAttribute?.docList[indexForm]?.signItems.find(signItem => (signItem.taskContactId === taskContact?.taskContactId || signItem.signer === this.service.user.email)
                  && signItem.fieldName === this.fieldName && signItem.stepOrder === this.taskAttribute.currentLevel && signItem.taskContactId === taskContact?.taskContactId);
               if (!haveToSignItem) {
                  this.disabledRejectTask = true;
               }
               if (!this.isEmpty(this.form.controls[this.fieldName].value)) {
                  this.disabledRejectTask = false;
               }
            } else {
               // in case viewer
               if (this.form.controls[this.fieldName].value) {
                  this.disabledRejectTask = false;
               } else {
                  this.disabledRejectTask = true;
               }
            }
         } else {
            if (this.isStartFlow) {
               if (this.form.controls[this.fieldName].value) {
                  this.disabledRejectTask = false;
               } else {
                  this.disabledRejectTask = true;
               }
            } else {
               this.disabledRejectTask = false;
            }
            if (this.isViewOnly && !this.isCreateFile ) {
               this.defaultCursor = true;
            }
            // check in dms
            if (!this.isEmpty(this.form.controls[this.fieldName].value)) {
               this.defaultCursor = true;
            }
         }
      }
   }

   setIndexColorDocList(item) {
      let indexColor = 0;
      if (this.eformService.taskAttributeTemp.apvLevel) {
         const getSigners = [];
         for (const signers of this.eformService.taskAttributeTemp.apvLevel) {
            for (const signer of signers.signerList) {
               if (signer.action === 'Need to Sign') {
                  getSigners.push(signer);
               }
            }
         }
         indexColor = getSigners.findIndex((data) => parseInt(data.taskContactId, 10) === parseInt(item.taskContactId, 10));
         if (indexColor === -1) {
            indexColor = 5;
         }
      }
      return indexColor;
   }

   editSignature(): void {
      if (this.isPreview) {
         return;
      }
      if (this.disabledRejectTask) {
         return;
      }
      if (this.hasSignature){
         if (this.picSign) return;
         const token = this.service.user.token;
         const url = this.service.url + '/signature?token=' + token + '&lastmodify=' + Date.now() + '&init=false';
         this.service.toDataURL(url, (dataUrl) => {
            this.isSigner = false;
            this.picSign = dataUrl;
            this.imageSignaturePreview = this.picSign;
            this.form.controls[this.fieldName].setValue(this.picSign);
            let element = document.getElementById('holder' + this.fieldName);
            if (element) {
               element.style.backgroundColor = '#ffffff';
               element.style.opacity = '1';
            }
            const doc = this.taskAttribute?.docList[this.indexForm];
            if (doc) {
               doc['picSign'] = this.picSign;
            }
            this.ref.detectChanges();
         });
      } else {
         if (this.picSign) return;
         this.service.getProfile().subscribe((data: any) => {
            this.hasSignature = data.hasSignature;
            if (!this.fNameValue) {
               this.fNameValue = data.fName;
            }
            if (!this.lNameValue) {
               this.lNameValue = data.lName;
            }
            if (this.hasSignature) {
               this.editSignature();
            } else {
               this.createSignature();
            }
         });
      }
   }

   createSignature(): void {
      const registerSignDialog = this.dialog.open(RegisterSignatureComponent, {
         disableClose: true,
         data: this
      });
      registerSignDialog.componentInstance.signatureId = -1;
      registerSignDialog.componentInstance.imageSignatureOriginal = this.imageSignaturePreview;
      registerSignDialog.componentInstance.imageInitOriginal = this.imageInitializePreview;
      registerSignDialog.componentInstance.fullNameValue = this.fNameValue + ' ' + this.lNameValue;
      registerSignDialog.afterClosed().subscribe(result => {
         if (result) {
            this.imageSignaturePreview = registerSignDialog.componentInstance.imageSignaturePreview;
            this.picSign = this.imageSignaturePreview;
            this.checkValid = true;
            this.service.getProfile()
               .subscribe((data: any) => {
                  this.hasSignature = data.hasSignature;
                  this.form.controls[this.fieldName].setValue(this.picSign);
                  this.ref.detectChanges();
               });
         }
      });
   }

   selectSignature(): void {
      if (this.disabledRejectTask) {
         return;
      }
      let fieldName, taskContactId;
      fieldName = this.fieldName;
      taskContactId = this.taskContactId;
      this.selectSig.emit({fieldName, taskContactId});

   }

   onshowSignTool(flag) {
      this.showSignTool.emit(flag);
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }

   getSignatureBackgroundColor(fieldName: string, indexForm: number) {
      if (!indexForm && indexForm !== 0) return;
      if (!this.taskAttribute?.docList?.[indexForm]?.signItems) return;

      const currentSigner = this.taskAttribute?.apvLevel.find(
         (signer) => signer.order === this.taskAttribute.currentLevel
      );
      const taskContact = currentSigner?.signerList.find(
         (element) => element.signerEmail === this.service.user.email || element?.reassignEmail === this.service.user.email
      );
      if (currentSigner && taskContact && this.taskAttribute?.docList[indexForm]?.signItems) {
         const haveToSignItem = this.taskAttribute?.docList[indexForm]?.signItems.find(
            (signItem) => signItem.taskContactId === taskContact.taskContactId && signItem.fieldName === fieldName
         );

         if (haveToSignItem && haveToSignItem.taskStatus !== 'Completed' && haveToSignItem.taskStatus !== 'Reject' && this.form.controls[fieldName].value === '') {
            // #8b0000
            return 'rgba(139, 0, 0, 0.5)';
         } else {
            // #ffffff
            return 'rgba(255, 255, 255, 1)';
         }
      }
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes['isStartFlow'] && changes['isStartFlow'].currentValue) {
         if (!this.taskAttribute) {
            if (this.isStartFlow) {
               if (this.form.controls[this.fieldName].value) {
                  this.disabledRejectTask = false;
               } else {
                  this.disabledRejectTask = true;
               }
            } else {
               this.disabledRejectTask = false;
            }
         }
      }
   }

   openSignAllDialog(indexForm,fieldName): void {
      const currentLevel = this.taskAttribute?.currentLevel;
      if (!this.taskAttribute?.docList?.[indexForm]?.signItems) {
         return;
      }
      let signItem = this.taskAttribute?.docList[indexForm]?.signItems.find(item => item.fieldName === fieldName);
      if (signItem.flagSign) {
         return;
      } else {
         signItem.flagSign = true;
      }
      let o = this.taskAttribute?.docList[indexForm];
      if (this.taskAttribute?.docList?.length > 1 && !this.isAllFormSign(indexForm)) {
         if (o['isDialogShow'] === undefined) {
            o['isDialogShow'] = false;
         }
         if (this.taskAttribute?.docList?.[indexForm]?.signItems.filter(s => s.stepOrder === currentLevel).length >= 1 && this.isDialogShow(indexForm) && this.isHasSign()) {
            setTimeout(() => {this.signAllForm.emit()}, 0);
         }
      } else {
         if (this.isFirstSign(indexForm) || this.isLastSign(indexForm)) {
            o['isDialogShow'] = false;
            setTimeout(() => {this.signAllForm.emit()}, 0);
         }
      }
   }

   isHasSign(): boolean {
      if (!this.taskAttribute) {
         return false;
      }
      for (let doc of this.taskAttribute.docList) {
         if (doc.signItems) {
            for (let signItem of doc.signItems) {
               if (signItem.taskStatus !== 'Completed') {
                  return true;
               }
            }
         }
      }
      return false;
   }



   isDialogShow(indexForm: number): boolean {
      const currentLevel = this.taskAttribute.currentLevel;
      let cnt = 0;
      let signItemCnt = 0;
      let notSignCnt = 0;
      let formCnt = this.taskAttribute?.docList[indexForm]?.signItems?.filter(o => o.stepOrder === currentLevel)?.length | 0;
      let signFormCnt = this.taskAttribute?.docList[indexForm]?.signItems?.filter(o => o.flagSign && o.stepOrder === currentLevel)?.length | 0;
      let notSignFormCnt = this.taskAttribute?.docList[indexForm]?.signItems?.filter(o => !o.flagSign && o.stepOrder === currentLevel)?.length | 0;
      for (let doc of this.taskAttribute.docList) {
         if (doc.signItems) {
            for (let signItem of doc.signItems) {
               if (signItem.stepOrder === currentLevel) {
                  cnt++;
                  if (signItem.flagSign) {
                     signItemCnt++;
                  }
               }
            }
         }
      }
      notSignCnt = cnt - signItemCnt + notSignFormCnt;
      if ((notSignCnt === cnt) || (formCnt === signFormCnt)) {
         return true;
      }
      return false;
   }

   isAllFormSign(indexForm: number): boolean {
      const currentLevel = this.taskAttribute.currentLevel;
      let formCnt = this.taskAttribute?.docList[indexForm]?.signItems?.filter(o => o.stepOrder === currentLevel)?.length | 0;
      let signCnt = 0;
      for (let doc of this.taskAttribute.docList) {
         if (doc.signItems) {
            signCnt += doc.signItems.filter(o => o.stepOrder === currentLevel).length || 0;
         }
      }
      return formCnt === signCnt;
   }

   isFirstSign(indexForm: number): boolean {
      const currentLevel = this.taskAttribute.currentLevel;
      const signer = this.service.user.email;
      return this.taskAttribute?.docList[indexForm]?.signItems?.filter(o => o.flagSign && o.signer === signer && o.stepOrder === currentLevel)?.length === 1;
   }

   isLastSign(indexForm: number): boolean {
      const currentLevel = this.taskAttribute.currentLevel;
      const signer = this.service.user.email;
      let formCnt = this.taskAttribute?.docList[indexForm]?.signItems?.filter(o => o.signer === signer && o.stepOrder === currentLevel)?.length | 0
      let signFormCnt = this.taskAttribute?.docList[indexForm]?.signItems?.filter(o => o.flagSign &&  o.signer === signer && o.stepOrder === currentLevel)?.length | 0;
      return formCnt === signFormCnt
   }

   ngOnDestroy(): void {
      this.showFieldEmptyError?.unsubscribe();
      this.fieldValueChanges?.unsubscribe();
   }

   handleSignature() {
      if (this.taskAttribute) {
         const currentSigner = this.taskAttribute?.apvLevel.find(signer => signer.order === this.taskAttribute.currentLevel);
         const taskContact = currentSigner?.signerList.find(element => element.signerEmail === this.service.user.email || element?.reassignEmail === this.service.user.email);

         if (currentSigner && taskContact && this.taskAttribute?.docList[this.indexForm]?.signItems) {
            const haveToSignItem = this.taskAttribute?.docList[this.indexForm]?.signItems.find(signItem =>
               (signItem.taskContactId === taskContact?.taskContactId || signItem.signer === this.service.user.email) &&
               signItem.fieldName === this.fieldName &&
               signItem.stepOrder === this.taskAttribute.currentLevel &&
               signItem.taskContactId === taskContact?.taskContactId
            );
            if (haveToSignItem && (this.taskAttribute.taskStatus !== 'Completed' && this.taskAttribute.taskStatus !== 'Waiting') && this.isSigner === false) {
               this.picSign = undefined;
            } else {
               this.updateSignature();
            }
         } else {
            this.updateSignature();
         }
      } else {
         this.updateSignature();
      }
   }

   updateSignature() {
      const isEmail = (value: string): boolean => {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      };
      if (this.picSign && !isEmail(this.picSign)) {
         this.imageSignaturePreview = this.picSign;
         this.form.controls[this.fieldName].setValue(this.picSign);
      } else {
         this.picSign = undefined;
      }
   }

   showSignSignature(indexForm: number): void {
      if (!this.taskAttribute) {
         return;
      }
      const doc = this.taskAttribute.docList[indexForm];
      if (doc.signItems && doc.picSign) {
         for (let signItem of doc.signItems) {
            if (signItem.flagSign && signItem.fieldName === this.fieldName) {
               this.picSign = doc.picSign
               this.imageSignaturePreview = this.picSign;
               this.form.controls[this.fieldName].setValue(this.picSign);
               let element = document.getElementById('holder' + this.fieldName);
               if (element) {
                  element.style.backgroundColor = '#ffffff';
                  element.style.opacity = '1';
               }
            }
         }
      }
   }

}
